
import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";

export async function consoleGameList(
    console_id: string,
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `admin/console/${console_id}/game/list${queryString}`
    );
}

export async function consoleGameGet(
    item_id: string
) {
    return await clientAxios.get(
        `admin/console/game/${item_id}/show`
    );
}

export async function consoleGameCreate(
    console_id: string,
    payload: Partial<any>
) {
    return await clientAxios.post(
        `admin/console/${console_id}/game/create`,
        payload
    );
}

export async function consoleGameDelete(
    item_id: string,
) {
    return await clientAxios.del(
        `admin/console/game/${item_id}/delete`,
    );
}
